"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateCapiIntegrationRequestToJSON = exports.CreateCapiIntegrationRequestFromJSONTyped = exports.CreateCapiIntegrationRequestFromJSON = exports.instanceOfCreateCapiIntegrationRequest = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the CreateCapiIntegrationRequest interface.
 */
function instanceOfCreateCapiIntegrationRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
exports.instanceOfCreateCapiIntegrationRequest = instanceOfCreateCapiIntegrationRequest;
function CreateCapiIntegrationRequestFromJSON(json) {
    return CreateCapiIntegrationRequestFromJSONTyped(json, false);
}
exports.CreateCapiIntegrationRequestFromJSON = CreateCapiIntegrationRequestFromJSON;
function CreateCapiIntegrationRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'datasetId': !(0, runtime_1.exists)(json, 'dataset_id') ? undefined : json['dataset_id'],
    };
}
exports.CreateCapiIntegrationRequestFromJSONTyped = CreateCapiIntegrationRequestFromJSONTyped;
function CreateCapiIntegrationRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'dataset_id': value.datasetId,
    };
}
exports.CreateCapiIntegrationRequestToJSON = CreateCapiIntegrationRequestToJSON;
